import type { IInitializeCampaignFilter } from '../hooks';
import type { ReactNode } from 'react';

import { useMemo, createContext, useContext } from 'react';
import { useInitializeCampaignFilter } from '../hooks';

export interface ICampaignFilterContext extends IInitializeCampaignFilter {
  itemsPerPage?: number;
  isRunningOnly?: boolean;
}
export const CampaignFilterContext = createContext<ICampaignFilterContext | undefined>(undefined);
export interface ICampaignFilterProvider {
  children: ReactNode;
  itemsPerPage?: number;
  isRunningOnly?: boolean;
}
export const CampaignFilterProvider = ({
  children,
  itemsPerPage,
  isRunningOnly,
}: ICampaignFilterProvider) => {
  const initializeCampaignFilter = useInitializeCampaignFilter();

  const contextValue = useMemo<ICampaignFilterContext>(
    () => ({
      ...initializeCampaignFilter,
      itemsPerPage,
      isRunningOnly,
    }),
    [initializeCampaignFilter, itemsPerPage, isRunningOnly],
  );

  return (
    <CampaignFilterContext.Provider value={contextValue}>{children}</CampaignFilterContext.Provider>
  );
};

export const useCampaignFilterContext = () => {
  const context = useContext(CampaignFilterContext);
  if (!context) {
    throw new Error('GEMX_CONTEXT_IS_NOT_DEFINED');
  }
  return context;
};
